import * as React from 'react';
import { LinkedText } from './LinkedText';

interface CustomerCareSectionProps {
  items: string[];
}

export function CustomerCareSection({ items }: CustomerCareSectionProps) {
  return (
    <section className="whyus-care">
      <style>{`
        .whyus-care {
          padding: 72px 24px;
          background: #fff;
        }
        .whyus-care-inner {
          max-width: 720px;
          margin: 0 auto;
        }
        .whyus-care h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
        }
        .whyus-care .subtitle {
          font-size: 16px;
          color: #666;
          margin: 0 0 32px;
        }
        .whyus-checklist {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        .whyus-checklist li {
          display: flex;
          align-items: flex-start;
          gap: 14px;
          padding: 14px 18px;
          font-size: 16px;
          color: #333;
          font-weight: 500;
          line-height: 1.5;
          border-radius: 10px;
          margin-bottom: 8px;
          background: #f0fdf0;
        }
        .whyus-checklist li i {
          color: #1EAA25;
          font-size: 18px;
          flex-shrink: 0;
          margin-top: 2px;
        }
        @media (max-width: 640px) {
          .whyus-care h2 {
            font-size: 24px;
          }
        }
      `}</style>
      <div className="whyus-care-inner">
        <h2>Si algo sale mal, lo resolvemos. Sin vueltas.</h2>
        <p className="subtitle">No escondemos las políticas en letra chica.</p>
        <ul className="whyus-checklist">
          {items.map((item) => (
            <li key={item.slice(0, 48)}>
              <i className="fa fa-check-circle" />
              <span><LinkedText text={item} /></span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
